<template>
  <div>
    <div class="blocks">
      <div class="l-m-b-20 align-items-center d-flex justify-content-between">
        <div class="d-flex align-items-center title-search">
          <h1 class="pr-3">Filters</h1>
          <div class="input-group search">
            <button type="button" class="btn input-group-btn" @click="clearSearch">
              <i :class="[q ? 'fa fa-remove' : 'fa fa-search']" />
            </button>
            <input class="form-control search-input" type="text" v-model="q" @keyup="searchText($event)"
                   placeholder="Search"
            />
          </div>
        </div>
        <div class="col-2 text-right pr-0 mobile-hidden">
          <button class="btn btn-primary btn-schedule" @click.self="toggleShared">
            {{ showShared ? 'Hide shared' : 'Show shared' }}
          </button>
        </div>
      </div>
    </div>

    <template v-if="!filterTemplates">
      <vue-content-loading :width="800" :height="450">
        <rect v-for="x in 15" :key="x" x="10" :y="15*x*1.4" rx="5" ry="5" width="720" height="6" />
      </vue-content-loading>
    </template>
    <template v-else-if="!filterTemplates.length">
      <span>There are no results.</span>
    </template>
    <template v-else>
      <div class="blocks">
        <div class="filters-header w-100 d-flex align-items-center justify-content-between mb-2 p-2">
          <div class="mr-3 col-2 d-flex justify-content-start">
            Name
          </div>
          <div class="filters-header-value col-2 align-items-center justify-content-start flex-wrap">
            Page
          </div>
          <div class="filters-header-value col-3 align-items-center justify-content-start flex-wrap">
            Owner
          </div>
          <div class="filters-header-value col-1 align-items-center justify-content-start flex-wrap">
            Default
          </div>
          <div class="filters-header-value col-1 align-items-center justify-content-start flex-wrap">
            Shared
          </div>
          <div class="filters-header-value col-2 align-items-center justify-content-start flex-wrap">
            Updated at
          </div>
          <div class="filters-header-value col-1 align-items-center justify-content-end flex-wrap">
            &nbsp;
          </div>
        </div>
      </div>
      <div>
        <div class="blocks">
          <div v-for="(filterTemplate, ind) in filterTemplates" :key="ind" @click.self="user.id === filterTemplate.cluster_user.user_id && openEditFilterTemplate(filterTemplate)" class="w-100 d-flex align-items-center justify-content-between bg-white rounded p-2 mt-3">
            <div @click.self="user.id === filterTemplate.cluster_user.user_id && openEditFilterTemplate(filterTemplate)" class="mr-3 col-2 d-flex justify-content-start" style="min-width: 100px">
              {{ filterTemplate.name }}
            </div>
            <div @click.self="user.id === filterTemplate.cluster_user.user_id && openEditFilterTemplate(filterTemplate)" class="d-flex col-2 align-items-center justify-content-start flex-wrap">
              {{ filterTemplate.filter_route.name }}
            </div>
            <div @click.self="user.id === filterTemplate.cluster_user.user_id && openEditFilterTemplate(filterTemplate)" class="d-flex col-3 align-items-center justify-content-start flex-wrap">
              {{ filterTemplate.cluster_user.full_name }}
            </div>
            <div @click.self="user.id === filterTemplate.cluster_user.user_id && openEditFilterTemplate(filterTemplate)" class="d-flex col-1 align-items-center justify-content-start flex-wrap">
              {{ filterTemplate.default ? 'Yes' : 'No' }}
            </div>
            <div @click.self="user.id === filterTemplate.cluster_user.user_id && openEditFilterTemplate(filterTemplate)" class="d-flex col-1 align-items-center justify-content-start flex-wrap">
              {{ filterTemplate.shared ? 'Yes' : 'No' }}
            </div>
            <div @click.self="user.id === filterTemplate.cluster_user.user_id && openEditFilterTemplate(filterTemplate)" class="d-flex col-2 align-items-center justify-content-start flex-wrap">
              {{ filterTemplate.updated_at }}
            </div>
            <div class="d-flex col-1 align-items-center justify-content-end flex-wrap">
              <div class="dropdown">
                <button type="button" class="btn btn-secondary add-filter" :id="'dropdownMenuButton'+ind"
                        data-toggle="dropdown" aria-haspopup="true"
                        aria-expanded="false"
                />
                <div v-if="user.id === filterTemplate.cluster_user.user_id" class="dropdown-menu dropdown-menu-right" :aria-labelledby="'dropdownMenuButton'+ind">
                  <button class="dropdown-item nav-link btn"
                          @click="openEditFilterTemplate(filterTemplate)"
                  >
                    Edit Filter
                  </button>
                  <button class="dropdown-item nav-link btn"
                          @click="filterTemplateDelete = filterTemplate"
                  >
                    Remove Filter
                  </button>
                </div>
                <div v-else class="dropdown-menu dropdown-menu-right" :aria-labelledby="'dropdownMenuButton'+ind">
                  <button class="dropdown-item nav-link btn"
                          @click="sharedFilterTemplate = filterTemplate"
                  >
                    Manage Sharing
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row blocks">
          <div class="col-sm-6 mb-1 pl-0 text-black-50"
               v-if="meta.total"
          >
            Showing {{ meta.from }} - {{ meta.to }} of {{ meta.total }}
          </div>
          <pagination class="col-sm-6 mb-1 pr-0" :change-page="changePage" :meta="meta" />
        </div>
      </div>
    </template>

    <!-- Filters -->
    <transition name="slide-fade">
      <div class="l-modal-mask" v-if="showFilters" @click.self="showFilters = false">
        <div v-if="showFilters" class="filters-side-modal flex flex-column justify-content-start">
          <div @click="showFilters = !showFilters" class="pointer">
            <h1 class="modal-h1 l-m-b-20"><span class="btn btn-back" />Add Filter</h1>
          </div>
          <div>
            <p>
              Filters are applied automatically. You can remove them one by one with minus button or with clear filters button.
            </p>
          </div>
          <div class="l-bg-white">
            <div class="row">
              <div class="col">
                <div class="row filters">
                  <div class="col-12" v-if="companies && companies.length">
                    <div class="select-wrap">
                      <label>Companies</label>
                      <simple-select v-model="filters.company"
                                     :options="companies"
                                     :input-id="'status-select'"
                                     placeholder="Select Company"
                                     @input="triggerSearch"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-auto">
            <div class="col">
              <button type="button" class="btn btn-not-active text-dark w-100" @click="clearFilters"
                      v-if="filters.company"
              >
                Clear filters
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- Update Filter Template -->
    <transition name="slide-fade">
      <div class="l-modal-mask" v-show="showEditFilterTemplate" @click.self="closeAllModals">
        <div class="sidebar-right">
          <div class="filters-form-wrapper">
            <div class="w-100">
              <h1 class="modal-h1 mb-3">
                <button type="button"
                        class="btn btn-back"
                        @click="closeAllModals"
                />
                Update Filter
              </h1>
              <form class="form-right" v-if="editFilterTemplate" @submit.prevent="saveEditFilterTemplate"
                    @keydown="clearError($event)"
                    autocomplete="no"
              >
                <div class="row">
                  <div class="col p-1">
                    <div class="select-wrap">
                      <label>Name: </label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="editFilterTemplate.name"
                        placeholder="Enter Name"
                        maxlength="100"
                      />
                    </div>
                    <error-field :errors="errors" field="name" />
                  </div>
                </div>
                <div class="row">
                  <div class="col p-1">
                    <div class="select-wrap">
                      <label>Default: </label>
                      <simple-select v-model="editFilterTemplate.default"
                                     :options="booleanOptions"
                                     :input-id="'default-select'"
                                     placeholder="Default"
                      />
                    </div>
                    <error-field :errors="errors" field="default" />
                  </div>
                </div>
                <div class="row">
                  <div class="col p-1">
                    <div class="select-wrap">
                      <label>Shared: </label>
                      <simple-select v-model="editFilterTemplate.shared"
                                     :options="booleanOptions"
                                     :input-id="'shared-select'"
                                     placeholder="Shared"
                      />
                    </div>
                    <error-field :errors="errors" field="shared" />
                  </div>
                </div>
                <div class="buttons-down text-right">
                  <button type="button" class="btn btn-delete float-left" @click="filterTemplateDelete = originalEditFilterTemplate">
                    Delete
                  </button>
                  <button type="button" class="btn btn-secondary" @click="closeAllModals">
                    Cancel
                  </button>
                  <button class="btn btn-primary ld-ext-right"
                          :disabled="buttonDisabled"
                          :class="loadingButton ? 'running' : ''"
                  >
                    Update
                    <span class="ld ld-ball ld-flip" />
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <modal v-if="filterTemplateDelete !== null" @close="filterTemplateDelete = null">
      <div slot="header">
        <h4 class="text-black-50 d-flex align-items-center justify-content-start">Delete Filter: {{ filterTemplateDelete.name }}</h4>
      </div>
      <div slot="body">
        <p class="text-center">Are you sure you want to delete filter with name {{ filterTemplateDelete.name }}?</p>
      </div>
      <div slot="footer" class="text-center">
        <button class="btn btn-success" @click="removeFilterTemplate">Yes</button>
        <button class="btn btn-danger" @click="filterTemplateDelete = null">No</button>
      </div>
    </modal>

    <modal v-if="sharedFilterTemplate !== null" @close="sharedFilterTemplate = null">
      <div slot="header">
        <h4 class="text-black-50 d-flex align-items-center justify-content-start">Share Filter: {{ sharedFilterTemplate.name }}</h4>
      </div>
      <div slot="body">
        <p class="text-center">Add or remove filter from your list.</p>
        <p class="text-center">
          <input id="default-checkbox" v-model="sharedFilterTemplate.default" type="checkbox" />
          <label for="default-checkbox">Set as default</label>
        </p>
      </div>
      <div slot="footer" class="text-center">
        <button class="btn btn-success" @click="shareFilterTemplate">Add filter</button>
        <button class="btn btn-danger" @click="removeSharedFilterTemplate">Remove filter</button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios';
import toastr from 'toastr';
import { mapActions, mapState } from 'vuex';
import Errors from '../../../classes/Errors';
import Modal from '../../Modal';
import Pagination from '../../Pagination';

export default {
  name: 'FilterTemplates',
  components: { Pagination, Modal },
  data: () => {
    return {
      ascOrDesc: null,
      booleanOptions: [{ id: 1, name: 'Yes' }, { id: 0, name: 'No' }],
      buttonDisabled: false,
      editFilterTemplate: null,
      errors: new Errors(),
      filterTemplateDelete: null,
      filterTemplates: null,
      loadingButton: false,
      meta: {},
      originalEditFilterTemplate: null,
      page: '',
      q: '',
      selectedKey: null,
      sharedFilterTemplate: null,
      showEditFilterTemplate: false,
      showFilters: false,
      showShared: 0,
      timer: null,
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.dispatchUser,
    }),
    clearFiltersButtonShouldBeDisabled() {
      return this.filters.company;
    },
  },
  watch: {
    filters() {
      this.triggerSearch();
    },
    ascOrDesc() {
      this.triggerSearch();
    },
    selectedKey() {
      this.triggerSearch();
    },
  },
  mounted() {
    this.triggerSearch();
  },
  methods: {
    ...mapActions(['getFilterTemplates']),
    clearSearch() {
      this.q = '';
      this.page = '';
      this.triggerSearch();
    },
    searchText(e) {
      if (/^[a-zA-Z0-9]$/.test(e.key) || e.keyCode === 8 || e.keyCode === 13) {
        const vm = this;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          vm.triggerSearch();
        }, 500);
      }
    },
    clearFilters() {
      this.q = '';
      this.filters = {
        companyId: '',
      };
      this.triggerSearch();
    },
    removeFilter(filterName) {
      this.$set(this.filters, filterName, '');
      this.triggerSearch();
    },
    sortBy(sort) {
      if (this.selectedKey === sort) {
        // eslint-disable-next-line no-unused-expressions
        this.ascOrDesc === 'asc' ? (this.ascOrDesc = 'desc') : (this.ascOrDesc = 'asc');
      } else {
        this.selectedKey = sort;
      }
    },
    openEditFilterTemplate(filterTemplate) {
      if (this.user.id === filterTemplate.cluster_user.user_id) {
        this.editFilterTemplate = { ...filterTemplate };
        this.originalEditFilterTemplate = filterTemplate;
        this.showEditFilterTemplate = true;
      }
    },
    closeAllModals(withRefresh = false) {
      if (withRefresh === true) {
        this.triggerSearch();
      }
      this.originalEditFilterTemplate = null;
      this.showEditFilterTemplate = false;
      this.editFilterTemplate = null;
      this.filterTemplateDelete = null;
      this.sharedFilterTemplate = null;
    },
    saveEditFilterTemplate() {
      axios
        .patch(`clusters/users/filters/${this.editFilterTemplate.id}`, this.editFilterTemplate)
        .then(() => {
          this.closeAllModals(true);
          this.getFilterTemplates();
          toastr.success('Successfully updated filter');
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        });
    },
    triggerSearch() {
      axios
        .get(
          `clusters/users/filters?q=${this.q}&sort=${
            this.selectedKey && this.ascOrDesc ? `${this.selectedKey}|${this.ascOrDesc}` : ''
          }&page=${this.page}&with_shared=${this.showShared}`,
        )
        .then(response => {
          this.filterTemplates = response.data.data;
          this.meta = response.data.meta;
        })
        .catch(() => {});
    },
    toggleShared() {
      this.showShared = this.showShared ? 0 : 1;
      this.triggerSearch();
    },
    clearError(event) {
      this.errors.clear(event.target.name);
    },
    removeFilterTemplate() {
      axios
        .delete(`clusters/users/filters/${this.filterTemplateDelete.id}`)
        .then(() => {
          this.closeAllModals(true);
          this.getFilterTemplates();
          toastr.success('Successfully deleted filter');
        })
        .catch(() => {
          toastr.error('Server error');
        });
    },
    shareFilterTemplate() {
      const data = {
        default: this.sharedFilterTemplate.default,
        filter_template_id: this.sharedFilterTemplate.id,
      };
      axios
        .post(`clusters/users/filters/shared`, data)
        .then(() => {
          this.closeAllModals(true);
          this.getFilterTemplates();
          toastr.success('Successfully added filter');
        })
        .catch(() => {
          toastr.error('Server error');
        });
    },
    removeSharedFilterTemplate() {
      axios
        .delete(`clusters/users/filters/shared?filter_template_id=${this.sharedFilterTemplate.id}`)
        .then(() => {
          this.closeAllModals(true);
          this.getFilterTemplates();
          toastr.success('Successfully removed filter');
        })
        .catch(() => {
          toastr.error('Server error');
        });
    },
    changePage(pageNum) {
      this.filterTemplates = true;
      this.page = pageNum;
      this.triggerSearch();
    },
  },
};
</script>
<style scoped>
.filters-header {
  display: flex;
  background: #3f4247;
  box-shadow: 0 2px 0 rgba(33, 37, 41, 0.0263604);
  border-radius: 2px;
  height: 32px;
  justify-content: space-between;
  color: white;
  font-weight: bold;
}

.filters-form-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.buttons-down {
  width: 100%;
  border-top: 1px solid #eeeeee;
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/FilterTemplates/FilterTemplates.vue